import {ActionTypes} from "../constants/action-types";

export function setJobPositionData(data){
    return {
        type: ActionTypes.SET_JOB_POSITION_DATA,
        payload: data
    };
}
